import { action, thunk } from 'easy-peasy'
import { admin } from '../../../api/index'

export const QoSAdminModel = {
	// States
	admin: null,
	adminProfile: null,
	// Setters
	setAdmin: action((state, admin) => {
		state.admin = admin
	}),
	setAdminProfile: action((state, adminProfile) => {
		state.adminProfile = adminProfile
	}),
	// Custom Function
	QoSAdminSignIn: thunk(async (actions, { username, password }) => {
        const res = await admin.signin(username, password, 1)

        if (res && res?.status === 200) {
			if (res.data?.requiresTwoFactor || res.data?.requiresEnrollment) {
				return { requiresTwoFactor: true, challenge: res.data }
			}

			actions.setAdmin(res.data)
			return { authenticated: true, response: res.data }
		}

		return { authenticated: false }
    }),
	startTwoFactorEnrollment: thunk(async (actions, challengeToken) => {
		const res = await admin.startTwoFactorEnrollment(challengeToken)
		return res && res.status === 200 ? res.data : null
	}),
	verifyTwoFactor: thunk(async (actions, payload) => {
		const res = await admin.verifyTwoFactor(payload.challengeToken, payload.code)
		if (res && res.status === 200) {
			actions.setAdmin(res.data)
			return res.data
		}
		return null
	}),
	confirmTwoFactorEnrollment: thunk(async (actions, payload) => {
		const res = await admin.confirmTwoFactorEnrollment(payload.challengeToken, payload.code)
		if (res && res.status === 200) {
			actions.setAdmin(res.data)
			return res.data
		}
		return null
	}),
	adminSignout: thunk(actions => {
		actions.setAdmin(null)
	}),
	getAdminProfile: thunk(async actions => {
		const res = await admin.me()
		if (res && res?.status === 200) {
			actions.setAdminProfile(res.data)
		}
	}),
}
